import React from 'react'

function TicketTotal(props) {
    return (
        <h4 className="price-total">RD$ {props.price}</h4>
    )
}

export default TicketTotal;


// WEBPACK FOOTER //
// ./src/Components/Ticket/ticketTotal.js